import {Collection} from './Collection';

export class DealerProfile {
  /**
   * Default profiles
   */
  static DEFAULT_ALL = 'All';
  static DEFAULT_NONE = 'None';

  public id: number;
  public name: string;
  public collections: Collection[];
}
